// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hlo5","rootMobile":"styles_rootMobile__z21Bw"};